import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * PremiumBadge — small pill labelled "Wkrótce" / "Coming soon".
 * Non-interactive, purely presentational.
 * `tone`: 'purple' (default) or 'gold' — pick whichever complements the surrounding card.
 */
export function PremiumBadge({ tone = "purple", className = "", testId }) {
  const { t } = useI18n();
  const color = tone === "gold" ? "#F4C95D" : "#A78BFA";
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-full border ${className}`}
      style={{
        color,
        borderColor: `${color}55`,
        background: `${color}12`,
        letterSpacing: "0.06em",
      }}
      data-testid={testId}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: color }}
      />
      <span className="uppercase font-medium tracking-wide">
        {t("premium.badge.soon")}
      </span>
    </span>
  );
}
